var chunkMapping = {
	"880": [
		456,
		3586,
		3873,
		5532,
		5931,
		9589
	]
};
var idToExternalAndNameMapping = {
	"456": [
		"default",
		"./routes",
		3907
	],
	"3586": [
		"default",
		"./routes",
		2819
	],
	"3873": [
		"default",
		"./manifest",
		3907
	],
	"5532": [
		"default",
		"./manifest",
		6892
	],
	"5931": [
		"default",
		"./manifest",
		2819
	],
	"9589": [
		"default",
		"./routes",
		6892
	]
};
var idToRemoteMap = {
	"456": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"3586": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"3873": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"5532": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"5931": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"9589": [
		{
			"externalType": "promise",
			"name": ""
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"456": {
		"shareScope": "default",
		"name": "./routes",
		"externalModuleId": 3907,
		"remoteName": ""
	},
	"3586": {
		"shareScope": "default",
		"name": "./routes",
		"externalModuleId": 2819,
		"remoteName": ""
	},
	"3873": {
		"shareScope": "default",
		"name": "./manifest",
		"externalModuleId": 3907,
		"remoteName": ""
	},
	"5532": {
		"shareScope": "default",
		"name": "./manifest",
		"externalModuleId": 6892,
		"remoteName": ""
	},
	"5931": {
		"shareScope": "default",
		"name": "./manifest",
		"externalModuleId": 2819,
		"remoteName": ""
	},
	"9589": {
		"shareScope": "default",
		"name": "./routes",
		"externalModuleId": 6892,
		"remoteName": ""
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}